import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { PtoEntry } from "@/hooks/use-pto-entries";
import { useUpdatePtoEntry } from "@/hooks/use-pto-entries";
import { PtoEntryForm } from "./PtoEntryForm";

interface PtoEntryEditDialogProps {
  entry: PtoEntry | null;
  onOpenChange: (open: boolean) => void;
}

/**
 * Edit dialog — wraps the shared PtoEntryForm. A dialog (not a routed detail
 * page) keeps the entries list simple; see .claude/rules/frontend.md.
 */
export function PtoEntryEditDialog({ entry, onOpenChange }: PtoEntryEditDialogProps) {
  const updateEntry = useUpdatePtoEntry(entry?.id ?? "");

  return (
    <Dialog open={entry !== null} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit PTO entry</DialogTitle>
          <DialogDescription>Update this time-off entry.</DialogDescription>
        </DialogHeader>
        {entry && (
          <PtoEntryForm
            defaultValues={entry}
            submitLabel="Save"
            isSaving={updateEntry.isPending}
            onCancel={() => onOpenChange(false)}
            onSubmit={(result) =>
              updateEntry.mutate(result, { onSuccess: () => onOpenChange(false) })
            }
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
